const imageSizes = '(min-width: 1280px) 33vw, (min-width: 768px) 50vw, 100vw';

export { imageSizes };
